import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { bookingListComponent } from './bookingList.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [bookingListComponent],
  exports: [
    bookingListComponent
  ],
  providers: [
  ]
})
export class bookingListComponentModule { }
